exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-wrapper[data-v-13877386]{position:relative;height:100%;width:100%}.app-wrapper[data-v-13877386]:after{content:\"\";display:table;clear:both}.app-wrapper.mobile.openSidebar[data-v-13877386]{position:fixed;top:0}.drawer-bg[data-v-13877386]{background:#000;opacity:0.3;width:100%;top:0;height:100%;position:absolute;z-index:999}.hideSidebar .fixed-header[data-v-13877386]{width:100%}.mobile .fixed-header[data-v-13877386]{width:100%}\n", ""]);

// exports
